import React from 'react';
import KickImage from 'Reuseables/KickImage';
import PopularItem from '../../Molecules/PopularItem';

import { IPopularProps } from './Popular.definitions';

/** CSS import */
import Styles from './Popular.module.scss';
import useFetchHomePopularData from 'Pages/Blog/Hooks/useFetchHomePopularData';

import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, RectShape } from 'react-placeholder/lib/placeholders';
import moment from 'moment';

const Popular: React.FC<IPopularProps> = ({}: IPopularProps) => {
  const { fetchPopularData, data, isFetching } = useFetchHomePopularData();

  React.useEffect(() => {
    fetchPopularData();
  }, []);

  const Placeholder = React.useMemo(
    () => (
      <div className={Styles['placeholder']}>
        {Array.from({ length: 8 }).map((_, index) => (
          <div className={Styles['placeholder-item']}>
            <RectShape color="#eeeeee" className={Styles['image']} />
            <TextBlock rows={3} color="#eeeeee" />
          </div>
        ))}
      </div>
    ),
    [],
  );

  return (
    <div className={Styles['wrapper']}>
      <p className={Styles['title']}>Popular</p>
      <ReactPlaceholder ready={!isFetching} customPlaceholder={Placeholder}>
        {data.map((item) => (
          <PopularItem
            key={item.id}
            title={item.title}
            image={item.thumbnail?.URL}
            date={moment(item.created_at).format('MMMM DD, YYYY')}
            slug={item.slug}
          />
        ))}
      </ReactPlaceholder>
    </div>
  );
};

export default Popular;
